import { Order, OrderMetaInterface } from "./Order";

export type RevisionStatus = "init" | "pending" | "completed";

export type RevisionPaymentStatus =
  | "NOT_NEEDED"
  | "PAYMENT_TO_GG_PENDING"
  | "PAYMENT_TO_GG_SUCCESS"
  | "PAYMENT_TO_GG_FAILED"
  | "PAYMENT_TO_SELLER_PENDING"
  | "PAYMENT_TO_SELLER_SUCCESS"
  | "PAYMENT_TO_SELLER_FAILED"
  | "REFUND_TO_BUYER_PENDING"
  | "REFUND_TO_BUYER_SUCCESS"
  | "REFUND_TO_BUYER_FAILURE";

export class Revision {
  id: string;
  metaData: OrderMetaInterface;
  amountPaid: number;
  requestDesc: string;
  requestAttachments: string[];
  paymentId?: string;
  deliveryId?: string;
  order: Order | string;
  status: RevisionStatus;
  paymentStatus: RevisionPaymentStatus;
  createdAt: string;
  updatedAt: string;

  constructor(data: any) {
    this.id = data._id;
    this.metaData = data.metaData;
    this.amountPaid = data.amountPaid;
    this.requestDesc = data.requestDesc;
    this.requestAttachments = Array.isArray(data?.requestAttachments)
      ? data.requestAttachments.filter((url: unknown): url is string => typeof url === "string")
      : [];
    this.paymentId = data.paymentId;
    this.deliveryId = data.deliveryId;
    this.order = data.order;
    this.status = data.status;
    this.paymentStatus = data.paymentStatus;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
